<template>
    <button v-on:click="goBack"><slot>Back</slot></button>
</template>

<script>
export default {
    props: ["to"],
    name: "ButtonBack",
    methods: {
        goBack: function () {
            const router = this.$router;
            router.push(this.to);
        },
    },
};
</script>
